import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteAssetTypeSaga,
  getAssetTypeDetailsSaga,
  getAssetTypeListSaga,
} from "src/store/asset-types/saga";
import { AssetTypeDetailDto, AssetTypeDto } from "src/store/asset-types/type";
import AssetTypeCreateForm from "./create";
import AssetTypeEditForm from "./edit";
const AssetTypePage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<AssetTypeDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<AssetTypeDetailDto>();
  const columns = [
    {
      text: t("AssetType.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("AssetType.PageTitle")}
        metaTag={t("AssetType.MetaTag")}
        gridProps={{
          addTitle: t("AssetType.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getAssetTypeListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getAssetTypeDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: AssetTypeDto) =>
              t("AssetType.DeleteQA", {
                name: data.Name,
              }),
            action: deleteAssetTypeSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <AssetTypeCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getAssetTypeListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <AssetTypeEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getAssetTypeListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default AssetTypePage;
